import { usePrototypeContext } from './usePrototypeContext'
import {
  useGoBack,
  useGoForwards,
  useRestartPrototype,
} from '@sketch-hq/sketch-web-renderer'
import { useKey } from 'react-use'
import { keyWithoutModifier } from '@sketch/utils'

/**
 * Keyboard shortcuts for the prototype player.
 */
export function useKeyboardShortcuts() {
  const { prototypeArtboardUUID } = usePrototypeContext()
  const restartPrototype = useRestartPrototype()
  const goBack = useGoBack()
  const goForwards = useGoForwards()

  useKey(keyWithoutModifier('ArrowLeft'), () => {
    goBack()
  })

  useKey(keyWithoutModifier('ArrowRight'), () => {
    goForwards()
  })

  useKey(keyWithoutModifier('r'), () => {
    restartPrototype(prototypeArtboardUUID)
  })
}
